'use client';

import { useTheme as useNextTheme } from 'next-themes';

export const useTheme = () => {
  return useNextTheme();
};
